import { render, staticRenderFns } from "./OrderOncecard.vue?vue&type=template&id=04f4f8db&"
import script from "./OrderOncecard.vue?vue&type=script&lang=js&"
export * from "./OrderOncecard.vue?vue&type=script&lang=js&"
import style0 from "./OrderOncecard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports